'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactIntl = require('@liveauctioneers/react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactFastCompare = require('react-fast-compare');

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _urls = require('../../utils/urls');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppHeaderMeta = function (_Component) {
    (0, _inherits3.default)(AppHeaderMeta, _Component);

    function AppHeaderMeta() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AppHeaderMeta);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppHeaderMeta.__proto__ || (0, _getPrototypeOf2.default)(AppHeaderMeta)).call.apply(_ref, [this].concat(args))), _this), _this.shouldComponentUpdate = function (nextProps) {
            return !(0, _reactFastCompare2.default)(_this.props, nextProps);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AppHeaderMeta, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                intl = _props.intl,
                pathname = _props.pathname,
                whiteLabel = _props.whiteLabel;
            var formatMessage = intl.formatMessage;


            var indexOfQuestion = pathname.indexOf('?');
            var path = !pathname.includes('?') ? pathname : pathname.substring(0, indexOfQuestion);
            var canonical = '' + baseUrl + path;
            var iOSAppUrl = 'https://itunes.apple.com/us/app/live-auctions/id321243082';

            var description = formatMessage({ id: 'get_in_on_the_auction' });
            var title = formatMessage({ id: 'bid_in_online_auctions' });

            return (0, _jsx3.default)(_reactHelmet2.default, {
                titleTemplate: '%s'
            }, void 0, !pathname.includes('/console/') && (0, _jsx3.default)('meta', {
                name: 'apple-itunes-app',
                content: 'app-id=321243082'
            }), (0, _jsx3.default)('link', {
                rel: 'canonical',
                href: canonical
            }), (0, _jsx3.default)('meta', {
                name: 'description',
                content: description
            }), (0, _jsx3.default)('title', {}, void 0, title), (0, _jsx3.default)('meta', {
                property: 'og:description',
                content: description
            }), (0, _jsx3.default)('meta', {
                property: 'og:image',
                content: _urls.logoUrl
            }), (0, _jsx3.default)('meta', {
                property: 'og:image:height',
                content: '600'
            }), (0, _jsx3.default)('meta', {
                property: 'og:image:width',
                content: '600'
            }), (0, _jsx3.default)('meta', {
                property: 'og:locale',
                content: 'en_US'
            }), (0, _jsx3.default)('meta', {
                property: 'og:site_name',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                property: 'og:title',
                content: title
            }), (0, _jsx3.default)('meta', {
                property: 'og:url',
                content: canonical
            }), (0, _jsx3.default)('meta', {
                property: 'og:type',
                content: 'website'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:country',
                content: 'US'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:googleplay',
                content: 'com.liveauctioneers.and'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:ipad',
                content: '321243082'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:id:iphone',
                content: '321243082'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:googleplay',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:ipad',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:name:iphone',
                content: 'LiveAuctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:googleplay',
                content: 'https://play.google.com/store/apps/details?id=com.liveauctioneers.and'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:ipad',
                content: iOSAppUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:app:url:iphone',
                content: iOSAppUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:card',
                content: 'summary_large_image'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:description',
                content: description
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:domain',
                content: 'liveauctioneers.com'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:image',
                content: _urls.logoUrl
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:site',
                content: '@liveauctioneers'
            }), (0, _jsx3.default)('meta', {
                name: 'twitter:title',
                content: title
            }), whiteLabel && (0, _jsx3.default)('meta', {
                name: 'robots',
                content: 'noindex, nofollow'
            }));
        }
    }]);
    return AppHeaderMeta;
}(_react.Component);

exports.default = (0, _reactIntl.withIntlContext)(AppHeaderMeta);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/AppHeaderMeta.js
// module id = HgIS
// module chunks = 60